import React from "react";
import { DynamicTab, NewTab, PageTabAdv } from "../../../../components";
import ButtonList from "./ButtonsList/ButtonList";
import TabList from "./ButtonsList/TabList";
import IonsList from "./ButtonsList/IonsList";
import { useLocation } from "react-router-dom";

const ButtonsList = () => {
  const location = useLocation();
  const fullHashPath = location.hash.slice(1).split("/");

  const tabList = [
    {
      title: "Button",
      page: <ButtonList />,
      type: "main",
    },
    {
      title: "Tab",
      page: <TabList />,
      type: "main",
    },
    {
      title: "Icon",
      page: <IonsList />,
      type: "main",
    },
  ];
  return (
    <div className="mt-5 flex-1 flex overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="outlined"
        //mainTabsShow={3}
        mode="url"
        tabId="buttons-list"
      />
    </div>
  );
};

export default ButtonsList;
